import VendorsEdit from "./VendorsEdit";
import VendorsList from "./VendorsList";

export default {
  list: VendorsList,
  edit: VendorsEdit,
};
